// CartItemList.jsx
import React from 'react';
import { PlusCircleIcon, TrashIcon } from '@heroicons/react/20/solid';
import DishCard from './DishCard';

export const CartItemList = ({ items, onEditItem, onAddMore, onClearCart }) => {
  if (!items || items.length === 0) return null;

  return (
    <>
      <div className="flex justify-between px-4 mt-4 items-center">
        <label className="block uppercase tracking-wide text-on-surface text-sm font-bold">
          Items
        </label>
        <div className="flex flex-row justify-end space-x-2 items-center">
          <PlusCircleIcon
            className="h-6 w-6 text-primary"
            onClick={onAddMore}
          />
          <TrashIcon className="h-6 w-6 text-secondary" onClick={onClearCart} />
        </div>
      </div>
      <table className="min-w-full mb-6 pt-10">
        <tbody>
          {items
            .filter(
              item =>
                item.paired_with !== undefined &&
                !item.paired_with?.is_pairing_option,
            )
            .map(item => (
              <DishCard
                menuItem={item}
                onClick={() => onEditItem(item)}
                key={item.cart_insert_ts.toString()}
              />
            ))}
        </tbody>
      </table>
    </>
  );
};
